export { SuiUtilityModule } from "./index";
//# sourceMappingURL=public.js.map


//////////////////
// WEBPACK FOOTER
// ../~/ng2-semantic-ui/dist/misc/util/public.js
// module id = 1091
// module chunks = 0